const API_URL = process.env.NODE_ENV === "development" ? "/api" : "/api";

export default API_URL;
